import { c as n, cB as i } from "../../../_utils/cssr/index.js";
const l = n([i("input-number-suffix", `
 display: inline-block;
 margin-right: 10px;
 `), i("input-number-prefix", `
 display: inline-block;
 margin-left: 10px;
 `)]);
export {
  l as default
};



//////////////////
// WEBPACK FOOTER
// ./~/@oppein/op-web-components/dist/es/~/.pnpm/naive-ui@2.42.0_vue@3.5.18/~/naive-ui/es/input-number/src/styles/input-number.cssr.js
// module id = 1656
// module chunks = 41